<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-bottom: 5px;"
        
        @click="openAdd()"
        >添加</el-button
      >
      <el-button type="danger" size="mini" style="margin-bottom: 5px;"  @click="open"
        >删除</el-button
      >
      <el-button
        type="success"
        size="mini"
        
        style="margin-bottom: 5px;"
        @click="getRoleinfo"
        >刷新</el-button
      >
      <div>
         <span style="padding: 0 10px">管理员名称</span>
      <!-- 搜索框 -->
      <el-input
        v-model="name"
        placeholder="请输入管理员名称"
        style="width: 200px; heigth: 30px; line-height: 30px;margin-bottom: 5px;"
        clearable
      />
      </div>
      <!-- 选择框 -->
      <!-- <span style="margin:0 10px">角色</span>
      <el-select v-model="option" placeholder="请选择" clearable  >
        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select> -->
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px;margin-bottom: 5px;"
        @click="select()"
        >筛选</el-button
      >
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="showtabelData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1061px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="50"
        :selectable="checkSelectable"
      />
      <el-table-column prop="username" label="账号" width="100" />
      <el-table-column prop="name" label="姓名" width="100" />
      <el-table-column prop="roleStr" label="角色" width="150">
        <template slot-scope="scoped">{{
          scoped.row.roleStr.toString()
        }}</template>
      </el-table-column>
      <el-table-column prop="loginIp" label="最后登录IP" width="150" />
      <el-table-column label="创建时间" width="155">
        <template slot-scope="scope">{{ scope.row.createDate }}</template>
      </el-table-column>
      <el-table-column label="最后登录时间" width="155">
        <template slot-scope="scope">{{ happenTimeFun(scope.row.loginDate) }}</template>
      </el-table-column>
      <el-table-column prop="state" label="状态" width="100">
        <template slot-scope="scope">
          <span :style="scope.row.isEnabled ? 'color:#00c759' : 'color:red'">{{
            scope.row.isEnabled ? "正常" : "已禁用"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.isSystem">-</div>
          <el-button
            v-else
            type="primary"
            class="edit-button"
            size="mini"
            
            @click="edit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getRoleinfo"
    />

    <!-- 添加用户弹窗 -->
    <el-dialog
      :visible.sync="add_dialogVisible"
      width="570px"
      :close-on-click-modal="false"
      @closed="handleClose"
    >
      <!-- 添加用户表格 -->
      <el-form
        ref="addform"
        :model="addform"
        label-width="80px"
        :rules="addrules"
      >
        <el-form-item label="账号" prop="username">
          <el-input v-model="addform.username" placeholder="请输入管理员账号" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="addform.password"
            placeholder="请输入管理员密码"
            type="password"
          />
        </el-form-item>
        <el-form-item label="确定密码" prop="checkpassword">
          <el-input
            v-model="addform.checkpassword"
            placeholder="请再次输入管理员密码"
            type="password"
          />
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="addform.name" placeholder="请再次输入管理员姓名" />
        </el-form-item>
        <el-form-item label="角色" prop="roleIds">
          <el-checkbox-group v-model="addform.roleIds">
            <el-checkbox
              v-for="(item, index) in options"
              :key="index"
              :label="item.name"
            />
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="设置" prop="isEnabled">
          <el-radio-group v-model="addform.isEnabled">
            <el-radio :label="true">已启用</el-radio>
            <el-radio :label="false">已禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="edit-button"
            :loading="buttongLoding"
            @click="addManagement"
            >立即创建</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 编辑用户弹窗 -->
    <el-dialog
      :visible.sync="edit_dialogVisible"
      width="570px"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <!-- 编辑用户表格 -->
      <el-form ref="editform" :model="editform" label-width="80px">
        <el-form-item label="账号" prop="count">
          <el-input
            v-model="editform.username"
            placeholder="请输入管理员账号"
            disabled
          />
        </el-form-item>
        <el-form-item label="密码">
          <el-input
            v-model="editform.editpassword"
            placeholder="请输入管理员密码"
            type="password"
          />
        </el-form-item>
        <el-form-item label="确定密码">
          <el-input
            v-model="editform.editcheckpassword"
            placeholder="请再次输入管理员密码"
            type="password"
          />
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input
            v-model="editform.name"
            placeholder="请再次输入管理员姓名"
          />
        </el-form-item>
        <el-form-item label="角色">
          <el-checkbox-group v-model="editform.roleStr">
            <el-checkbox
              v-for="(item, index) in options"
              :key="index"
              :label="item.name"
            />
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="设置" prop="state">
          <el-radio-group v-model="editform.isEnabled">
            <el-radio :label="true">已启用</el-radio>
            <el-radio :label="false">已禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="edit-button"
            :loading="buttongLoding"
            @click="editManagement()"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination },
  data() {
    // 自定义检验规则
    // 校验第一次密码
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.addform.checkpassword !== "") {
          this.$refs.addform.validateField("checkpassword");
        }
        callback();
      }
    };
    // 校验第二次密码
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.addform.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    // 校验邮箱
    var validateEmail = (rule, value, callback) => {
      const reg =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (value && !reg.test(value)) {
        callback(new Error("请输入正确的邮箱!"));
      } else {
        callback();
      }
    };
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      showtabelData: [], // 展示的表单信息
      // 添加表单
      addform: {
        username: "",
        password: "",
        checkpassword: "",
        email: "",
        name: "",
        roleIds: [],
        department: "",
        isEnabled: true,
      },
      // 修改表单
      editform: {
        role: [],
      },
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      add_dialogVisible: false, // 添加弹窗
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加载
      // 校验规则
      addrules: {
        username: [
          { required: true, message: "请输入管理员账号", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
        checkpassword: [{ validator: validatePass2, trigger: "blur" }],
        email: [{ validator: validateEmail, trigger: "blur" }],
        roleIds: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个角色",
            trigger: "change",
          },
        ],
        department: [
          {
            required: true,
            message: "请输入管理员账号部门名称",
            trigger: "blur",
          },
        ],
        state: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      buttongLoding: false, // 按钮加载
    };
  },
  mounted() {
    this.getRoleinfo();
  },
  methods: {
    happenTimeFun(num) {
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
    // 禁止选择
    checkSelectable(row) {
      return row.isSystem == false;
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getRoleinfo();
    },
    // 获取角色列表
    getAllroles() {
      this.$api.administrator
        .getAllRoles()
        .then((res) => {
          this.options = res;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        });
    },
    // 获取表单信息
    getRoleinfo() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        name: this.name,
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.administrator
        .getAdministratorList(params)
        .then((res) => {
          this.showtabelData = res.records; 
          this.filter();
          this.total = res.total;
          // this.showtabelData.forEach((item) => {
          //   item.loginDate = item.loginDate
          //     ? this.$api.operation.getdateNoTime(item.loginDate)
          //     : "";
          // });
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 关闭添加弹窗
    handleClose() {
      this.$refs.addform.resetFields();
    },
    // 关闭修改弹窗
    editClose(done) {
      this.editInfo = {};
      done();
    },
    // 删除选中项
    handleDel() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.administrator
        .delAdministrator(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getRoleinfo();
        });
    },
    // 打开新增弹窗
    openAdd() {
      this.getAllroles();
      this.add_dialogVisible = true;
    },
    // 打开编辑弹窗
    edit(row) {
      this.getAllroles();
      this.editform = JSON.parse(JSON.stringify(row));
      this.edit_dialogVisible = true;
    },
    // 添加用户
    addManagement() {
      this.$refs.addform.validate((valid) => {
        if (valid) {
          this.buttongLoding = true;
          var roleIds = this.mapRole(this.addform.roleIds);
          // var _password =JSON.parse(JSON.stringify(this.addform.checkpassword))
          var params = {
            username: this.addform.username,
            password: this.addform.checkpassword,
            email: this.addform.email,
            name: this.addform.name,
            roleIds: roleIds.toString(),
            department: this.addform.department,
            isEnabled: this.addform.isEnabled,
          };
          this.$api.administrator
            .addAdministrator(params)
            .then((res) => {
              this.$message.success(res);
              this.add_dialogVisible = false;
              this.getRoleinfo();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });
        }
      });
      // this.add_dialogVisible=true
    },
    // 更新用户信息
    editManagement() {
      var roleIds = this.mapRole(this.editform.roleStr);
      if (this.editform.isSystem) {
        return this.$message.error("你不能更改系统用户");
      }
      this.buttongLoding = true;
      var params = {
        id: this.editform.id,
        department: this.editform.department,
        // password:md5(_password)||"",
        isEnabled: this.editform.isEnabled,
        email: this.editform.email,
        roleIds: roleIds.toString(),
        name: this.editform.name,
      };
      // 如果需要密码修改
      if (this.editform.editpassword) {
        if (this.editform.editpassword != this.editform.editcheckpassword) {
          return this.$message.error("两次密码不相同");
        }
        params.password = this.editform.editcheckpassword;
      }
      this.$api.administrator
        .updateAdministrator(params)
        .then((res) => {
          this.$message.success(res);
          this.getRoleinfo();
          this.edit_dialogVisible = false;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 打开删除弹窗
    open() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何角色");
      }
      this.$confirm("此操作将永久删除该管理员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDel();
        })
        .catch(() => {
          
        });
    },
    // 匹配权限
    mapRole(roleIds) {
      var _role = [];
      roleIds.forEach((role) => {
        var index = this.options.findIndex((item) => item.name == role);
        _role.push(this.options[index].id);
      });
      return _role;
    },
    // 权限列表数据过滤
    filter() {
      this.showtabelData.forEach((item) => {
        var roleStr = [];
        item.roles.forEach((role) => {
          roleStr.push(role.name);
        });
        item.roleStr = roleStr;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
::v-deep .el-input__inner{
  padding: 0 8px !important;
}
</style>
